import axios from "axios";
import { track, EVENTS, getFbCookies } from "../utils/meta-pixel";
import { pixelCodeOf } from "../constant/products";

const BASE_API_URL = "/api/payment";

//金流 service
//  價格與折扣一律由後端提供，前端不自己算 ——
//  自己算會出現「畫面顯示 38% 但實際收費不同」這種最難查的問題。
class PaymentService {
  //P-1 方案清單（公開，不需登入）
  //  line 只有緋紅在用：它的商品名稱隨故事線不同
  //  （單身的人看到「八字合婚」「你們之間」很詭異）。
  //  不帶就回中性的那一組，其他產品一律忽略。
  plans(type = "ask", line) {
    return axios.get(`${BASE_API_URL}/plans`, { params: { type, line } });
  }

  //P-3 我的票券餘額
  //  回 { gua, ask } —— 兩種券各自計數（見 models/user 的說明）：
  //    gua  問卦券（伏爻子）
  //    ask  問事券（白夜）
  tickets() {
    return axios.get(`${BASE_API_URL}/tickets`);
  }

  //P-2 發票選項（公開）
  //  類型與愛心碼由後端提供，前端不寫死 ——
  //  愛心碼填錯要等到開立時才會失敗，那時錢已經收了。
  invoiceOptions() {
    return axios.get(`${BASE_API_URL}/invoice-options`);
  }

  //P-4 建立訂單，取得綠界表單參數（要登入）
  //
  //  **票券**用這支 —— 券要發到帳號上，沒有帳號就沒有地方可以發。
  //  報告類請走下面的 checkoutGuest（那支不擋登入，轉化率差很多）。
  //
  //  發票資訊要在建單當下一起送：綠界付完款不會再問一次。
  //
  //  回來的 { action, params } 要用 submitToEcpay 組表單送出，不能用 axios
  //  （見 utils/ecpay-redirect 的說明）。
  checkout(productID, invoice) {
    //  InitiateCheckout 送在這裡而不是五個呼叫端各送一次 ——
    //  散在五個檔案裡，之後加產品一定會漏掉其中一支，
    //  而漏掉的那一支在報表上只會看起來「成效比較差」，查不出原因。
    //
    //  content_ids 送的是**產品代號**不是方案代號：漏斗前半段只知道網址，
    //  兩套混著送 Meta 會當成兩個不相干的內容（見 constant/products 的 pixelCodeOf）。
    track(EVENTS.INITIATE_CHECKOUT, {
      content_ids: [pixelCodeOf(productID)],
      content_name: pixelCodeOf(productID),
    });
    return axios.post(`${BASE_API_URL}/checkout`, {
      productID,
      invoice,
      //  帶著 Pixel 的 cookie 給後端存進訂單 —— 付款成功時由
      //  Conversions API 一起送，Meta 才對得回「是哪一次點擊帶來的」
      //  （見 utils/meta-pixel 的 getFbCookies）。
      fb: getFbCookies(),
    });
  }

  //P-4b 訪客結帳（不需登入）
  //  報告類商品用這支。身分靠 invoice.email —— 之後使用者用同一個信箱
  //  的 Google 登入進來，歷史訂單就撈得回來。
  //
  //  intake 一定要帶：報告是依問診資料生成的，而那份資料只活在前端的
  //  location state 裡，跳去綠界再導回來就沒了。不在建單時存進訂單，
  //  付完錢就不知道要算誰的盤。
  //
  //  回來的 { action, params } 要用 postToEcpay 組表單送出，不能用 axios
  //  （見 utils/ecpay-redirect 的說明）。
  checkoutGuest(productID, invoice, intake) {
    track(EVENTS.INITIATE_CHECKOUT, {
      content_ids: [pixelCodeOf(productID)],
      content_name: pixelCodeOf(productID),
    });
    return axios.post(`${BASE_API_URL}/checkout-guest`, {
      productID,
      invoice,
      intake,
      fb: getFbCookies(),
    });
  }

  //P-9 訂單狀態（公開）
  //  給付款完成頁用 —— 那個人可能從頭到尾沒登入過。
  //  只回「付了沒」這種程度的資訊，不回發票與問診資料（orderID 在網址上）。
  orderStatus(orderID) {
    return axios.get(`${BASE_API_URL}/order-status/${orderID}`);
  }

  //P-10 用 orderID 查報告（公開）
  //  白夜是訪客結帳，買的人可能沒有帳號 —— 要登入的 R-2 他查不到自己的報告。
  //  回 { orderStatus, reportStatus, content }，content 只在 done 時有值。
  orderReport(orderID) {
    return axios.get(`${BASE_API_URL}/order-report/${orderID}`);
  }

  //P-11 留下對這份報告的評價（公開）
  //  身分靠 orderID，同 P-10 —— 買的人可能沒有帳號。
  //  重複送出不會失敗，後端會回既有的那一則。
  orderReview(orderID, payload) {
    return axios.post(`${BASE_API_URL}/order-review/${orderID}`, payload);
  }

  //P-5 查單一訂單（付款完導回時確認結果用）
  order(orderID) {
    return axios.get(`${BASE_API_URL}/order/${orderID}`);
  }

  //P-6 我的訂單列表
  orders() {
    return axios.get(`${BASE_API_URL}/orders`);
  }
}

const paymentService = new PaymentService();
export default paymentService;
